import { render } from "./ProfessionalInfoPage.vue?vue&type=template&id=6ce5378b&scoped=true"
import script from "./ProfessionalInfoPage.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoPage.vue?vue&type=script&lang=js"

import "./ProfessionalInfoPage.vue?vue&type=style&index=0&id=6ce5378b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce5378b"]])

export default __exports__